import React from "react";
import { Card, Col, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import "../../css/mouse.css";
import { StarsRate } from "./stars-rate.component";

interface MostRecentPartsItem {
    uuid: string;
    description: string;
    rate: number;
    value: string;
    image: string;
}

export function MostRecentParts(props) {
    const { items } = props;
    const navigate = useNavigate();

    const prepareDescription = (text) => {
        return text.length > 27 ? text.substring(0, 27) + "..." : text;
    };

    const handleItem = (productUrl: string) => {
        navigate(`/product/${productUrl}`);
    }

    return (
        <Card className={`b-theme-primary ${props.mt ? `mt-${props.mt}` : null}`}>
            {props.title && (
                <Card.Header className="bg-theme-primary text-light text-uppercase fw-bold p-3">
                    {props.title}
                </Card.Header>
            )}
            <Card.Body>
                {items.map((element: MostRecentPartsItem) => (
                    <Col key={element.uuid} className={"fw-bold p-3 mt-1 col-12 pointer"} onClick={() => handleItem(element.url)}>
                        <Row>
                            <Col>
                                <img className="d-block w-100" src={element.image} alt="" />
                            </Col>
                            <Col>
                                <small className={"text-capitalize"}>
                                    {prepareDescription(element.description)}
                                    <br />
                                    <StarsRate rateValue={element.rate} />
                                    <br />
                                    R$ {element.value}
                                </small>
                            </Col>
                        </Row>
                    </Col>
                ))}
            </Card.Body>
        </Card>
    );
}
